/*
常量配置
*/
/* eslint-disable */

const SITE_NAME = 'MT-parter';// 站点名称
const SITE_VERSION = '1.0.0';// 版本号
const SITE_URI = 'https://m.maitao.com';
const CURRNET_SITE_URI = `${location.protocol}//${location.host}`;
const BASE_URI = '/mtinterface';// server uri
const BASE_URI_TEST = '/proxy/api';
const TIME_OUT = 15000;// 所有的请求超时阈值,
const DEFAULT_UID = 'U0616122310224223058'; // 默认用户id,慎用
const WX_DEBUG = false; // 微信的debug模式，打开后会有alert,
const WX_API_LIST = ['onMenuShareAppMessage', 'onMenuShareTimeline', 'onMenuShareQQ',
  'onMenuShareQZone', 'chooseImage', 'uploadImage', 'chooseWXPay', 'hideMenuItems',
  'showMenuItems', 'scanQRCode', 'getLocation', 'openLocation']; //  微信的jsApiList，需要用到的接口在此扩展，
const WX_SHARE_MENU_LIST = ['menuItem:share:appMessage', 'menuItem:share:timeline', 'menuItem:share:qq', 'menuItem:share:QZone'];
const DEFAULT_SHARE_TITLE = '麦淘亲子'; // 微信分享默认标题
const DEFAULT_SHARE_DESC = '陪伴成长，发掘梦想'; // 微信分享副标题
const DEFAULT_SHARE_LINK = location.href; // 微信分享默认链接
const DEFAULT_SHARE_ICON = 'https://img.maitao.com/logo_android.jpg'; // 微信分享默认图标
const ABSOLUTE_ASSETS_PATH = '/static'; // 存放资源的绝对路径 absolute
const DEFAULT_AVATAR = 'https://img.maitao.com/635889050405854558'; // 默认头像
const APP_DOWNLOAD_LINK = 'http://a.app.qq.com/o/simple.jsp?pkgname=com.maitao.mtqzy';
const WX_OFFICIAL_QRCODE = 'https://img.maitao.com/e4acb05a-9884-4922-a013-e84096c7db96.png';
const MINI_PROGRAM_RAW_ID = `${process.env.NODE_ENV === 'production' ? 'gh_88a705bb7920' : 'gh_3e08f4ec20cd'}`;
export default {
  SITE_NAME,
  SITE_VERSION,
  SITE_URI,
  CURRNET_SITE_URI,
  BASE_URI,
  BASE_URI_TEST,
  TIME_OUT,
  DEFAULT_UID,
  WX_DEBUG,
  WX_API_LIST,
  WX_SHARE_MENU_LIST,
  DEFAULT_SHARE_ICON,
  DEFAULT_SHARE_DESC,
  DEFAULT_SHARE_LINK,
  DEFAULT_SHARE_TITLE,
  ABSOLUTE_ASSETS_PATH,
  DEFAULT_AVATAR,
  APP_DOWNLOAD_LINK,
  MINI_PROGRAM_RAW_ID,
  WX_OFFICIAL_QRCODE,
};
